// src/components/SchoolInfoRatingBlocks/SchoolInfoRatingBlocks.js

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import style from './SchoolInfoRatingBlocks.scss';

function RatingBlocks({ score, total }) {
  const blocks = [];
  for (let i = 1; i <= total; i++) {
    blocks.push(
      <div
        key={i}
        className={i <= score ? style.blockFilled : style.blockEmpty}
      />
    );
  }
  return <div className={style.blocksContainer}>{blocks}</div>;
}

RatingBlocks.propTypes = {
  score: PropTypes.number.isRequired,
  total: PropTypes.number,
};
RatingBlocks.defaultProps = {
  total: 4,
};

export default withStyles(style)(RatingBlocks);
